export default "__VITE_ASSET__CkcTzqy8__"